'use client';

import { useEffect, useState } from 'react';
import { ThrottleHelpers } from '@headless-workspace/utils';
import { useReferencedState } from './useReferencedState';

type ScrollDirectionResults = 'up' | 'down' | undefined;
export type UseScrollDirectionResult = { scrollDirection: ScrollDirectionResults; scrollDifference: number };

const SCROLL_THROTTLE_LIMIT = 80; // 16*5

export const useScrollDirection: () => UseScrollDirectionResult = () => {
    const [scrollDirection, setScrollDirection] = useState<ScrollDirectionResults>(undefined);
    const [scrollDifference, setScrollDifference] = useState<number>(0);
    const [lastScrollY, setLastScrollY] = useReferencedState<number>(0);

    useEffect(() => {
        const handleScrollDirection = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY.current) {
                setScrollDirection('down');
            } else if (currentScrollY < lastScrollY.current) {
                setScrollDirection('up');
            }

            setScrollDifference(currentScrollY - lastScrollY.current);
            setLastScrollY(currentScrollY);
        };

        const throttledHandleScrollDirection = ThrottleHelpers.throttleCallback(
            handleScrollDirection,
            SCROLL_THROTTLE_LIMIT,
        );

        window.addEventListener('scroll', throttledHandleScrollDirection);

        return () => {
            window.removeEventListener('scroll', throttledHandleScrollDirection);
        };
    }, [lastScrollY, setLastScrollY]);

    return { scrollDirection, scrollDifference };
};
